import {AbstractControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {ChipItem} from '@mydocma/component-library/src/lib/chips/chip-item';
import {ChipListValidationError, ChipValidationError, CustomValidationError} from './custom-validation-error';

export declare interface CustomValidatorFn {
    (control: AbstractControl): CustomValidationError | null;
}

export declare interface AsyncCustomValidatorFn {
    (control: AbstractControl): Promise<CustomValidationError | null> | Observable<CustomValidationError | null>;
}

export declare interface CustomChipListValidatorFn {
    (control: AbstractControl): ChipListValidationError | null;
}

export const emailRegExp = new RegExp('([A-Za-z0-9-".:;!#$%&\'*+\\/=?^_`{|}~äöüÄÖÜß]|[\\s])*[<]?(?:[A-Za-z0-9-!#$%&\'*+\\/=?^_`{|}~äöüÄÖÜß]+(?:\\.[A-Za-z0-9-!#$%&\'*+\\/=?^_`{|}~äöüÄÖÜß]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")[@](?:(?:[A-Za-z0-9äöüÄÖÜß_](?:[A-Za-z0-9-äöüÄÖÜß_]*[a-z0-9])?\\.)+[A-Za-z0-9äöüÄÖÜß_](?:[A-Za-z0-9-äöüÄÖÜß_]*[A-Za-z0-9äöüÄÖÜß_])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.)A-Za-z0-9äöüÄÖÜß_(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-äöüÄÖÜß_]*[A-Za-z0-9äöüÄÖÜß_]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])[>]?');

export const timeRegExp = new RegExp('^([0-1][0-9]|2[0-3]):[0-5][0-9]$');

export function customEmailValidator(
    control: AbstractControl
): CustomValidationError | null {
    const value = control.value;
    if (!value) {
        return null;
    }
    if (Array.isArray(value)) {
        const invalidItem = value.find((item) => {
            return !emailRegExp.test(item?.text ?? '');
        });

        if (invalidItem) {
            return {
                mydocmaCustomEmailError: 'FORM.fields.errors.invalidEmail'
            };
        }
    } else if (typeof value === 'string') {
        if (!emailRegExp.test(value)) {
            return {
                mydocmaCustomEmailError: 'FORM.fields.errors.invalidEmail'
            };
        }
    }

    return null;
}


export interface ChipValidationResult {
    isValid: boolean;
    errorText?: string;
}


export function customChipListValidator(
    validateChip: (chip: ChipItem) => ChipValidationResult,
    errorText: string = 'FORM.fields.errors.invalidChipList'
): CustomChipListValidatorFn {

    return (control: AbstractControl): ChipListValidationError | null => {

        const chips: ChipItem[] = control.value;
        if (!Array.isArray(chips) || !chips.length) {
            return null;
        }

        const chipListError: ChipValidationError[] = [];

        chips.forEach((chip) => {
            const result = validateChip(chip);
            if (!result?.isValid) {

                chipListError.push({invalidChip: chip, validationError: result?.errorText ?? errorText});
            }
        });

        if (!chipListError.length) {
            return null;
        }

        return {
            mydocmaCustomError: chipListError[chipListError.length - 1].validationError,
            chipListError
        };
    };
}


export function customTimeValidator(
    control: AbstractControl
): CustomValidationError | null {
    const value = control.value;
    if (!value) {
        return null;
    }

    if (typeof value === 'string') {
        if (!timeRegExp.test(value)) {
            return {
                mydocmaCustomTimeError: 'FORM.fields.errors.invalidTime'
            };
        }
    }

    return null;
}
